<template>
    <div class="text-xs-center">
        <v-pagination
            v-if="pages > 1 && page.page_num <= pages"
            :value="page.page_num"
            :length="pages"
            :total-visible="$bp.smallScreen ? 5 : 8"
            @input="paginationTool($event)"
        ></v-pagination>
    </div>
</template>

<script>
export default {
    props: ["name", "page", "params", "path", "sendCommit", "sendFetch"],
    computed: {
        pages() {
            if (this.page.page_size == null || this.page.total_records == null) return 0;
            return Math.ceil(this.page.total_records / this.page.page_size);
        },
    },
    methods: {
        paginationTool(newPage) {
            let filters = JSON.parse(JSON.stringify(this.params));
            if (newPage > 1 && (newPage > this.page.page_num || newPage < this.page.page_num)) {
                filters.page_num = newPage;
            } else {
                delete filters.page_num;
            }
            if (this.path) {
                this.$router.push({ path: this.path, query: filters });
            } else if (this.name) {
                this.$router.push({ name: this.name, query: filters });
            } else if (this.sendCommit) {
                this.$store.commit(this.sendCommit, filters);
            } else if (this.sendFetch) {
                this.$store.dispatch(this.sendFetch, {
                    body: filters,
                });
            }
        },
    },
};
</script>
